import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import { Quote, ArrowRight } from "lucide-react";
import Avatar from "./Avatar";

export default function WallPreview() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let cancel = false;
    api.get("/testimonials")
      .then(({ data }) => { if (!cancel) setItems((data.items || []).slice(0, 3)); })
      .catch(() => {});
    return () => { cancel = true; };
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-12 py-20" data-testid="landing-wall-preview">
      <div className="flex items-end justify-between mb-10">
        <div>
          <p className="overline text-[#D47C59] mb-3">Fresh from the Backyard Wall 🌻</p>
          <h2 className="font-serif text-4xl md:text-5xl font-light tracking-tight">
            Real yards. Real people.
          </h2>
        </div>
        <Link to="/wall" className="btn-outline hidden sm:inline-flex" data-testid="landing-wall-cta">
          See the wall <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((t) => (
          <Link to="/wall" key={t.id} className="bb-card overflow-hidden group" data-testid={`landing-wall-card-${t.id}`}>
            <div className="overflow-hidden">
              <img
                src={`data:${t.image_mime || "image/png"};base64,${t.image_base64}`}
                alt={t.title}
                loading="lazy"
                decoding="async"
                className="w-full aspect-[4/3] object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="p-5">
              <Quote className="w-4 h-4 text-[#D47C59] mb-2" strokeWidth={1.5} />
              <p className="font-serif text-base leading-relaxed line-clamp-3">“{t.quote}”</p>
              <div className="flex items-center gap-2 mt-3">
                <Avatar name={t.display_name} src={t.avatar_url} size={28} testId={`landing-wall-avatar-${t.id}`} />
                <p className="text-xs text-[#5C6B62] font-light">{t.display_name}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
      <div className="mt-8 text-center sm:hidden">
        <Link to="/wall" className="btn-outline" data-testid="landing-wall-cta-mobile">
          See the wall <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  );
}
